

































































































































































































import Bowser from 'bowser'
import { debounce } from 'throttle-debounce'
import {
  defineComponent,
  onMounted,
  onBeforeUnmount,
  useRouter,
  useStore,
  useContext,
  ref,
  computed,
  useRoute,
  nextTick,
  watch,
} from '@nuxtjs/composition-api'
import LayoutBlocks from '@/components/LayoutBlocks.vue'

import { yaCounter } from '@/composition/ym'
import {
  mediaQueryHandler,
  scrollBarWidthHandler,
  userAgentHandler,
} from '@/packages/basis'
import {
  HeaderInfo,
  IHolidayTheme,
  Notification,
  SiteNotification,
} from '@/contracts/Settings'
import { useFeatureFlag } from '@/composition/useFeatureFlag'
import BlockButtonsItem from '@/components/BlockButtonsItem.vue'
import CityFromCookie from '@/components/CityFromCookie.vue'
import SectionCategoriesMenu from '@/components/Header/sections/SectionCategoriesMenu.vue'
import { useSearchBotHeaderLayout } from '@/composition/useSearchBotHeaderLayout'
import BlockMainPageSurvey from '@/components/BlockMainPageSurvey.vue'
import BlockTopMessageCommon from '@/components/BlockTopMessageCommon.vue'
import { useRegistry } from '@/composition/useRegistry'

const browsers = {
  safari: {
    desktop: 13,
    mobile: 12.4,
    tablet: 11,
  },
  opera: {
    desktop: 72,
    mobile: 3,
    tablet: 3,
  },
  chrome: {
    desktop: 87,
    mobile: 87,
    tablet: 87,
  },
  firefox: {
    desktop: 84,
    mobile: 38,
    tablet: 38,
  },
  edge: {
    desktop: 87,
    mobile: 87,
    tablet: 87,
  },
  'microsoft edge': {
    desktop: 87,
    mobile: 87,
    tablet: 87,
  },
  'samsung internet for android': {
    mobile: 13,
    tablet: 8,
  },
  'yandex browser': {
    desktop: 20,
    mobile: 20,
    tablet: 20,
  },
}

export default defineComponent({
  name: 'Layout',
  components: {
    BlockTopMessageCommon,
    BlockMainPageSurvey,
    SectionCategoriesMenu,
    CityFromCookie,
    BlockButtonsItem,
    BlockSiteNotification: () =>
      import('@/components/BlockSiteNotification.vue'),
    LayoutBlocks,
    BlockWorksNotify: () => import('@/components/BlockWorksNotify.vue'),
    FDebug: () => import('@/packages/basis/components/Debug.vue'),
  },
  setup() {
    const store = useStore()
    const isMobile = computed(() => store.getters['mediaQuery/isMobileMq'])
    const route = useRoute()
    const { $config } = useContext()

    const siteNotificationAccept = ref(
      process.browser
        ? localStorage.getItem('site-notification-accept') === 'true'
        : false
    )
    const notificationAccept = ref(
      process.browser
        ? localStorage.getItem(
            `notify-works-accepted${route.value.path?.replace(/\//g, '-')}`
          ) === 'true'
        : false
    )

    const { enabled: ffRedesignedHeader } = useFeatureFlag(
      'ff_redesigned_header'
    )
    const { enabled: ffHeaderNextEnabled } = useFeatureFlag(
      'ff_header_next_design'
    )
    // при новом хедере (ff_header_next_design) старые обёртки ff_redesigned_header не используются
    const ffNewHeaderEnabled = computed(
      () => !!ffRedesignedHeader.value && !ffHeaderNextEnabled.value
    )

    const headerInfo = computed(
      () => store.getters['settings/headerInfo'] as HeaderInfo
    )

    const registry = useRegistry()

    const isProsto = computed(() =>
      /(?:^|\/)prosto(?:\/|$)/.test(route.value.path || '')
    )

    const isBrandMediaLayout = computed(
      () => store.getters['registry/getRegistry'].BrandMediaDefaultLayout
    )

    const hideFooter = computed(() => store.getters['settings/getHideFooter'])
    const hideHeader = computed(() => store.getters['settings/getHideHeader'])

    const indented = computed(() => store.getters['intendet/GET_INTENDET'])
    const notification = computed<Notification>(
      () => store.getters['settings/notification']
    )
    const allSiteNotification = computed<SiteNotification>(
      () => store.getters['settings/allSiteNotification']
    )
    const holidayTheme = computed<IHolidayTheme>(
      () => store.getters['settings/holidayTheme']
    )
    const getActive = (activeFrom: string, activeTo: string) => {
      const planDateOn = activeFrom && new Date(activeFrom)
      const planDateOff = activeTo && new Date(activeTo)
      const today = new Date()

      return planDateOn < today && today < planDateOff
    }
    const notificationDateIsActive = computed(() =>
      getActive(
        notification.value.notificationStartTime,
        notification.value.notificationEndTime
      )
    )
    const siteNotificationDateIsActive = computed(() =>
      getActive(
        allSiteNotification.value.notificationStartTime,
        allSiteNotification.value.notificationEndTime
      )
    )

    onMounted(() => {
      if (process.browser) {
        window.addEventListener(
          'resize',
          debounce(50, () => {
            mediaQueryHandler(store)
          }),
          false
        )
        mediaQueryHandler(store)
        scrollBarWidthHandler(store)
        userAgentHandler(store)
      }
      const showPopup = sessionStorage.getItem('hideOldBrowser') !== 'true'
      const {
        parsedResult: {
          browser: { name: _name = '', version: _version = '' } = {},
          platform: { type: _type = '' } = {},
        } = {},
      } = Bowser.getParser(window.navigator.userAgent)
      const type = _type.toLowerCase()
      const name = _name.toLowerCase()
      const version = _version.split('.')[0]

      const isUnSupported =
        !type ||
        !name ||
        !version ||
        !browsers[name] ||
        !browsers[name][type] ||
        version < browsers[name][type]

      if (showPopup && isUnSupported && !hideFooter && !hideHeader) {
        yaCounter('browser')
        const router = useRouter()
        router.push({
          query: {
            toast: store.getters['settings/oldBrowserTitle'],
            description: store.getters['settings/oldBrowserDescription'],
            linkTitle: store.getters['settings/oldBrowserLinkTitle'],
            linkUrl: store.getters['settings/oldBrowserLinkUrl'],
            isBrowserPopup: 'true',
          },
        })
      }
    })
    onBeforeUnmount(() =>
      window.removeEventListener('resize', mediaQueryHandler, false)
    )
    const showDebug = $config.APP_ENV !== 'production'

    const closeSiteNotificationHandle = () => {
      siteNotificationAccept.value = true
    }
    const closeNotificationHandle = () => {
      notificationAccept.value = true
    }

    const showCityPopup = () => store.commit('popupCityList/SET_SHOWN', true)

    const visuallyHideHeader = computed(
      () => store.getters['settings/getHeaderVisuallyHidden']
    )

    const isHeaderNewDesign = computed(
      () => store.getters['settings/getHeaderFooterNewDesign']
    )

    const showSearchBot = computed(() => {
      return (
        ffNewHeaderEnabled.value &&
        isHeaderNewDesign.value &&
        store.getters['settings/showSearchBot']
      )
    })

    const showCategoriesMenu = computed(() => {
      return (
        ffNewHeaderEnabled.value &&
        isHeaderNewDesign.value &&
        store.getters['settings/showCategoriesMenu']
      )
    })

    const topMessage = computed(() => store.getters['settings/getTopMessage'])

    const headerElement = ref<HTMLElement>(null)
    const headerButtonsElement = ref<HTMLElement>(null)
    const headerTopMessageElement = ref<HTMLElement>(null)
    const headerFullWidth = ref<boolean>(false)
    let headerObserver = null

    watch(
      () => headerElement.value,
      () => {
        if (!process.browser) return
        if (ffNewHeaderEnabled.value) {
          headerObserver && headerObserver.disconnect()
          headerObserver = new IntersectionObserver(
            ([entry]) => {
              headerFullWidth.value = entry.intersectionRatio < 1
              store.commit(
                'settings/SET_HEADER_FULL_WIDTH',
                headerFullWidth.value
              )
            },
            {
              rootMargin: '-1px 0px 0px 0px',
              threshold: [1],
            }
          )

          nextTick(() => {
            headerObserver.observe(headerElement.value)
          })
        }
      },
      { immediate: true }
    )

    onBeforeUnmount(() => {
      headerObserver && headerObserver.disconnect()
    })

    const {
      searchBotElement,
      headerWrapperElement,
      headerStretcherElement,
      searchBotCollapsed,
      appear,
      fullsize,
      onToggleSearchBot,
      onCloseSearchBot,
      onSearchBotMounted,
    } = useSearchBotHeaderLayout(
      isMobile,
      headerButtonsElement,
      headerTopMessageElement,
      showSearchBot
    )

    return {
      showDebug,
      indented,
      hideFooter,
      hideHeader,
      notification,
      allSiteNotification,
      notificationDateIsActive,
      siteNotificationDateIsActive,
      holidayTheme,
      siteNotificationAccept,
      notificationAccept,
      closeSiteNotificationHandle,
      closeNotificationHandle,

      isProsto,
      isBrandMediaLayout,

      headerElement,
      headerFullWidth,
      ffNewHeaderEnabled,
      visuallyHideHeader,
      headerInfo,
      showCityPopup,
      showSearchBot,
      showCategoriesMenu,

      searchBotElement,
      headerWrapperElement,
      headerStretcherElement,
      searchBotCollapsed,
      appear,
      fullsize,
      onToggleSearchBot,
      onCloseSearchBot,
      onSearchBotMounted,

      headerButtonsElement,
      isHeaderNewDesign,
      isMobile,
      headerTopMessageElement,
      topMessage,

      registry,
    }
  },
})
